/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import Products from "./views/examples/products";
import ProductDetails from "./views/examples/ProductDetails";
import MainSliderManager from "./components/Slider";
import Advantages from "./components/Advantages";
import ArrivalsSectionManager from "./components/ArrivalsSectionManager";
import ProductCardsManager from "./components/ProductArrivalsCardsManager";
import CategoryManager from "./components/CategoryManager";
import BestSellerSection from "./components/Bestsellers";
import BestSelledProducts from "./components/BestSelledProducts";
import CategoriesHome from "./CategoriesHome";
import PromoAnimaliaManager from "./components/Promobanner";
import FooterManager from "./components/FooterManager";
import ClientOrdersTable from "./ClientOrdersTable";
import PetTypesManager from "./components/PetTypesManager";
import CatManager from "./components/CatManager";
import Logout from "./components/Logout";
import ContactsList from "./components/ContactsList";
import CreateTestimonials from "./components/CreateTestimonials";

function getIconForRoute(name) {
  switch (name.toLowerCase()) {
    case "dashboard":
      return "ni ni-tv-2 text-primary";
    case "tables":
      return "ni ni-bullet-list-67 text-red";
    case "main slider":
      return "ni ni-album-2 text-info";
    case "nos avantages":
      return "ni ni-check-bold text-success";
    case "nouveaux arrivages section":
      return "ni ni-cloud-upload-96 text-warning";
    case "meilleures ventes section":
      return "ni ni-chart-bar-32 text-orange";
    case "nouvel arrivage":
      return "ni ni-box-2 text-purple";
    case "products":
      return "ni ni-tag text-info";
    case "categories & subcategories":
      return "ni ni-collection text-yellow";
    case "product details":
      return "ni ni-single-copy-04 text-white";
    case "meilleures ventes":           // <-- ajouté ici
      return "ni ni-cart text-green";  // icône personnalisée pour cette route
    case "affiche promo": // <-- Add this line
      return "ni ni-image text-pink"; // <-- Choose an appropriate icon and color
          case "footer":
      return "ni ni-world-2 text-dark"; // <-- new icon for Footer
       case "commandes": // ✅ Added this line
      return "ni ni-delivery-fast text-orange"; // ✅ Choose any appropriate icon and color
        case "Nos Témoignages": // ✅ New one
    return "ni ni-chat-round text-purple"; // Pick an icon + color
                case "logout":
      return "ni ni-user-run text-danger"; // Use any icon you like
       case "reclamations & messages":
      return "ni ni-email-83 text-info"; // email icon with info color
    default:
      return "ni ni-bullet-list-67 text-default";
  }
}
function getcolor(name) {
  switch (name.toLowerCase()) {
    case "Product Details":
            return " text-white";
}}
var routes = [

  {
    path: "/slider",
    name: "Acceuil banner",
    icon: getIconForRoute("Main Slider"),
    component: <MainSliderManager />,
    layout: "/admin",
  },
  //   {
  //   path: "/homecategories",
  //   name: "Acceuil Categories",
  //   icon: getIconForRoute("Categories & Subcategories"),
  //   component: <CategoriesHome />,
  //   layout: "/admin",
  // },
  // {
  //   path: "/advantages",
  //   name: "Nos avantages",
  //   icon: getIconForRoute("Nos avantages"),
  //   component: <Advantages />,
  //   layout: "/admin",
  // },
  {
    path: "/arrivalssection",
    name: "Nouveaux Arrivages Section",
    icon: getIconForRoute("Nouveaux Arrivages Section"),
    component: <ArrivalsSectionManager />,
    layout: "/admin",
  },
  {
    path: "/sellerssection",
    name: "Meilleures ventes Section",
    icon: getIconForRoute("Meilleures ventes Section"),
    component: <BestSellerSection />,
    layout: "/admin",
  },
  // {
  //   path: "/arrivals",
  //   name: "Nouvel Arrivage",
  //   icon: getIconForRoute("Nouvel Arrivage"),
  //   component: <ProductCardsManager />,
  //   layout: "/admin",
  // },
  //   {
  //   path: "/Bsellers",
  //   name: "Meilleures Ventes",
  //   icon: getIconForRoute("meilleures ventes"),
  //   component: <BestSelledProducts />,
  //   layout: "/admin",
  // },

  {
    path: "/promo",
    name: "Affiche Promo",
    icon: getIconForRoute("Affiche Promo"),
    component: <PromoAnimaliaManager />,
    layout: "/admin",
  },
  {
    path: "/products",
    name: "Produits",
    icon: getIconForRoute("Products"),
    component: <Products />,
    layout: "/admin",
  },
        {
    path: "/pettype",
    name: " Types des Animeaux",
    icon: getIconForRoute("Categories & Subcategories"),
    component: <PetTypesManager />,
    layout: "/admin",
  },
      {
    path: "/cats",
    name: " Categories",
    icon: getIconForRoute("Categories & Subcategories"),
    component: <CatManager />,
    layout: "/admin",
  },


  //   {
  //   path: "/categorieschats",
  //   name: " Categories Des Chats",
  //   icon: getIconForRoute("Categories & Subcategories"),
  //   component: <CatCategoryManager />,
  //   layout: "/admin",
  // },

  //   {
  //   path: "/categorieschiens",
  //   name: " Categories Des Chiens",
  //   icon: getIconForRoute("Categories & Subcategories"),
  //   component: <DogCategoryManager />,
  //   layout: "/admin",
  // },


  {
    path: "/categories",
    name: "Sous-categories",
    icon: getIconForRoute("Categories & Subcategories"),
    component: <CategoryManager />,
    layout: "/admin",
  },

  {
    path: "/commandes",
    name: "Les Commandes",
    icon: getIconForRoute("Commandes"),
    component: <ClientOrdersTable />,
    layout: "/admin",
  },
    {
    path: "/Temoignages",
    name: "Nos Témoignages",
    icon: getIconForRoute("Nos Témoignages"),
    component: <CreateTestimonials />,
    layout: "/admin",
  },

{
  path: "/contacts",
  name: "Reclamations & Messages",
  icon: getIconForRoute("Reclamations & Messages"),
  component: <ContactsList/>,
  layout: "/admin",
},

  {
    path: "/footer",
    name: "Footer",
    icon: getIconForRoute("Footer"),
    component: <FooterManager />,
    layout: "/admin",
  },








{
  path: "/logout",
  name: "Logout",
  icon: getIconForRoute("Logout"),
  component: <Logout/>,
  layout: "/admin",
},
















{
  path: "/product/:id",
  name: getcolor("Product Details"),  // <<< THIS RETURNS " text-white"
  icon: getIconForRoute("Product Details"),
  component: <ProductDetails />,
  layout: "/admin",
},

];

export default routes;
